var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccessGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#287D3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44411 9.05719C6.92341 8.53649 6.07919 8.53649 5.55849 9.05719C5.03779 9.57789 5.03779 10.4221 5.55849 10.9428L8.22516 13.6095C8.74586 14.1302 9.59008 14.1302 10.1108 13.6095L15.4441 8.27614C15.9648 7.75544 15.9648 6.91122 15.4441 6.39052C14.9234 5.86983 14.0792 5.86983 13.5585 6.39052L9.16797 10.781L7.44411 9.05719Z",
    fill: "white",
    stroke: "#0C756F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccessGreenIcon);
export default __webpack_public_path__ + "static/media/check-success-green-icon.a4cf52561f9ca0a2225b0eebaa2dc111.svg";
export { ForwardRef as ReactComponent };